import wix from './wix';

const expand = () => {
  const eventName = 'Chat - Opened';
  wix.trackEvent('CustomEvent', {
    event: eventName,
    eventAction: eventName,
    eventCategory: 'Engagement',
    eventLabel: 'Chat',
  });
};

const collapse = () => {
  const eventName = 'Chat - Closed';
  wix.trackEvent('CustomEvent', {
    event: eventName,
    eventAction: eventName,
    eventCategory: 'Engagement',
    eventLabel: 'Chat',
  });
};

const lead = () => {
  wix.trackEvent('Lead', {
    action: 'Chat - Lead capture form submitted',
    label: 'Chat',
  });
};

export const wixAnalytics = {
  expand,
  collapse,
  lead,
};
